export function TimelinePhotoWrapper({ children }) {
    return (
        <div className={`tile is-parent is-vertical`}>
            <div className="tile is-child">{children}</div>
        </div>
    );
}
